import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { FaqsSectionModule } from 'src/app/components/faqs-section/module';
import { PricingFaqsWidgetComponent } from './pricing-faqs-widget.component';

@NgModule({
  declarations: [
    PricingFaqsWidgetComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    FaqsSectionModule,
  ],
  exports: [
    PricingFaqsWidgetComponent,
  ],
})
export class PricingFaqsWidgetModule { }
